import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'components/styledComponents';
import { Paper } from './style';

function DialogPaper({ loading = false, ...props }) {
  return <Loader component={Paper} loading={loading} {...props} spinnerSize="40" />;
}

DialogPaper.propTypes = {
  loading: PropTypes.bool
};

export default DialogPaper;
